import { ICreateGradingSchemeModel } from '../interfaces/create-grading-scheme.interface.model';

export class SetGradingSchemeToModule {
    static readonly type = '[GradingScheme] SetGradingSchemeToModule';

    constructor(public payload: ICreateGradingSchemeModel) {}
}
